import { render, staticRenderFns } from "./Fade.vue?vue&type=template&id=28c1d5d8&scoped=true&"
var script = {}
import style0 from "./Fade.vue?vue&type=style&index=0&id=28c1d5d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c1d5d8",
  null
  
)

export default component.exports